import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["visualizationSettingsMap"];
import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation } from 'data-fetching-client';
import { transformBackendViewToInternalFormat, convertInternalViewToBEFormat } from '../../viewsSearch/dataOperators/backendViews';
import { VIEWS_SEARCH_QUERY_NAME } from '../../viewsSearch/hooks/useFetchViewsSearch';
export const CREATE_SINGLE_VIEW_WITH_VISUALIZATION_MUTATION_NAME = 'createSingleViewWithVisualization';

// Define the structure of visualization settings

// Extended type that includes visualization settings

/**
 * Enhanced mutation for creating views with visualization settings
 */
export const CreateSingleViewWithVisualizationMutation = registerMutation({
  fieldName: CREATE_SINGLE_VIEW_WITH_VISUALIZATION_MUTATION_NAME,
  args: ['objectTypeId', 'name', 'state', 'teamId', 'private', 'namespaceName'],
  fetcher: args => {
    const visualizationSettingsMap = args.visualizationSettingsMap || {};

    // Remove visualizationSettingsMap from args before converting to backend format
    const viewArgs = _objectWithoutPropertiesLoose(args, _excluded);
    const backendView = convertInternalViewToBEFormat(viewArgs);
    const request = {
      view: backendView,
      visualizationSettingsMap
    };
    return http.post(`sales/v4/views/with-visualization-settings?namespace=${args.namespaceName}`, {
      data: request
    }).then(result => {
      return transformBackendViewToInternalFormat(result.persistedView);
    });
  }
});
export const useCreateSingleViewWithVisualizationMutation = view => {
  return useMutation(CreateSingleViewWithVisualizationMutation, {
    variables: view,
    refetchQueries: [VIEWS_SEARCH_QUERY_NAME],
    awaitRefetchQueries: true
  });
};